import { render } from "./UserLogs.vue?vue&type=template&id=680de138&scoped=true"
import script from "./UserLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./UserLogs.vue?vue&type=script&setup=true&lang=js"

import "./UserLogs.vue?vue&type=style&index=0&id=680de138&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680de138"],['__file',"resources/js/modules/ss_user/components/UserLogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "680de138"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('680de138', __exports__)) {
    api.reload('680de138', __exports__)
  }
  
  module.hot.accept("./UserLogs.vue?vue&type=template&id=680de138&scoped=true", () => {
    api.rerender('680de138', render)
  })

}


export default __exports__